import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import { v4 } from 'node-uuid';
import { LoadingIndicator } from 'common/components/preloader';
import NotificationSection from 'account/components/notification_section';
import map from 'lodash/map';
import OnsiteField from 'account/containers/onsite_field';
import EmailField from 'account/containers/email_field';
import EmailGroupCheckbox from 'account/containers/email_group_checkbox';
import EmailGroupFrequency from 'account/containers/email_group_frequency';
import SubcatWatchlist from 'account/containers/sub_category_watchlist';
import { Meta } from 'common/components/meta';
import Icon from 'common/components/svg_icon';

export default class NotificationSettings extends Component {
  constructor(props) {
    super(props);
    this.clearEmailGroup = this.clearEmailGroup.bind(this);
  }

  componentDidMount() {
    const { userId } = this.props;
    this.props.fetchOptions(userId);
    this.props.fetchSettings(userId);
  }

  clearEmailGroup() {
    this.props.clearEmailGroup();
    this.props.updateSettings();
  }

  render() {
    const { data, options, isCustomGroup, atAdmin, user } = this.props;

    if (!data || !options) {
      return <LoadingIndicator />;
    }

    return (
      <div id="content" className="l-content notification-settings">
        <Meta title="Notification Settings" />
        <section className="notification-section">
          <header className="notification-section-header">
            <div className="row">
              <div className="small-16 column">
                <h3>On crowdspring</h3>
                <p>
                  These settings control the
                  notifications { atAdmin? `${user.username} receives` : 'you receive' } in{' '}
                  { atAdmin? 'their' : 'your' } inbox on the crowdspring website.
                </p>
              </div>
            </div>
          </header>
          <div className="notification-subsections">
            <div className="row">
              <div className="small-16 columns">
                <SubcatWatchlist onsite={true} atAdmin={atAdmin} />

                { map(options.notifications, (section, key) => (
                  <NotificationSection
                    key={v4()}
                    name={key}
                    section={section}
                    Component={OnsiteField}
                    user={user}
                    atAdmin={atAdmin}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>
        <section className="notification-section">
          <header className="notification-section-header">
            <div className="row">
              <div className="small-16 column">
                <h3 className="section-header">Via email</h3>
                <p>
                  These settings control the crowdspring
                  notifications { atAdmin? `${user.username} receives` : 'you receive' } via email.
                </p>
              </div>
            </div>
          </header>

          <div className="row">
            <div className="small-16 column">
              <div className="email-options">
                <h5>Send me...</h5>
                { map(options.groups, (group, key) => (
                  <EmailGroupCheckbox group={group} id={key} key={v4()} atAdmin={atAdmin} />
                ))}
                <div className="radio">
                  <input
                    name="email-group"
                    id="email-group-custom"
                    checked={isCustomGroup}
                    onClick={this.clearEmailGroup}
                    type="radio"
                  />
                  <label htmlFor="email-group-custom" className="form-label">Custom</label>
                </div>
              </div>
              { !isCustomGroup && <EmailGroupFrequency /> }
            </div>
          </div>

          { isCustomGroup &&
          <div className="notification-subsections">
            <SubcatWatchlist atAdmin={atAdmin} />

            { map(options.notifications, (section, key) => (
              <NotificationSection
                key={v4()}
                name={key}
                section={section}
                Component={EmailField}
                user={user}
                atAdmin={atAdmin}
              />
            ))}
          </div>
          }
        </section>
      </div>
    );
  }
}

NotificationSettings.propTypes = {
  fetchOptions: PropTypes.func.isRequired,
  fetchSettings: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
  options: PropTypes.object,
  data: PropTypes.object,
  user: PropTypes.object.isRequired,
  atAdmin: PropTypes.bool.isRequired,

  isCustomGroup: PropTypes.bool,
  clearEmailGroup: PropTypes.func.isRequired,
  updateSettings: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./account/components/notification_settings.jsx